import axiosCall from './interceptor';
import URL from '../helper';

export const getAllContracts = async () => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts?page=1&limit=1000`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getContract = async (id) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/${id}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const createContract = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const updateContract = async (id, payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/${id}`;
  const response = await axiosCall('put', url, { id, ...payload });
  return response.data;
};

export const deleteContract = async (id) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}contracts/${id}`;
  const response = await axiosCall('delete', url);
  return response.data;
};

